"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isValidHostname = void 0;

function isValidHostname(hostname) {
  var hostPattern = /^[a-zA-Z0-9]{1}$|^[a-zA-Z0-9][a-zA-Z0-9\-]*[a-zA-Z0-9]$/;
  return hostPattern.test(hostname);
}

exports.isValidHostname = isValidHostname;